import EndorsementData from './EndorsementData';
import { Row, Col, Modal, Button, Icon } from 'antd';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

export default class EndorseeEmailModal extends React.Component {
    constructor(props) { 
        super(props); 
        this.state = {
            meta: null,
            data: [],
            metaRequest: {
                loading: null
            }
        };
    }

    componentDidUpdate(prevProps, prevState) {
        this.loadEndorsementEmailData(prevProps, prevState);
    }

    loadEndorsementEmailData(prev, prevState) {
        const
        { showModal, endorsementData } = this.props,
        { meta } = this.state,
        pShowModal = prev.showModal,
        cShowModal = showModal,
        pMetaLoading = prevState.metaRequest.loading,
        cMetaLoading = this.state.metaRequest.loading;

        // Get metadata for emails for endorsements.
        if (!pShowModal && cShowModal) {
            if (endorsementData != null) {
                const 
                { id, submittingOrganization } = endorsementData.person.encounter,
                { referenceId } = submittingOrganization;
                this.loadEndorsementsMetaData(id);
            }
        }

        if (meta != null && meta.length > 0) {
            if (pMetaLoading && !cMetaLoading ) {
                for (let i in meta) this.getSingleEndorsementEmailData(meta[i].emailId, i);
            }
        }
    }

    getSingleEndorsementEmailData(emailId, i){
        const options = {
            credentials: 'include',
            headers: {
                Authorization: `Bearer ${ window.session.token }`,
            },
        }
        //this.setState({metaRequest: {loading: true}});
        fetch( ssCommonUtils.setEnvPrefix(`/email/${emailId}`), options )
            .then(response => response.json())
            .then(data => this.updateSingelEmail(data, i))
            .catch(error => this.updateSingelEmail(null, i));
    }

    updateSingelEmail(data, i){

        this.setState( prevState => { 
            var newMeta = [...prevState.meta];
            var newData = [...prevState.data];
            newMeta[i] = data;
            newData[i] = data;

            return {
                ...prevState,
                meta: newMeta,
                data: newData
            }
        })
    }

    loadEndorsementsMetaData( encounterId ){
        const options = {
            method: 'POST',
            credentials: 'include',
            headers: {
                Authorization: `Bearer ${ window.session.token }`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({encounterId})
        }
        this.setState({metaRequest: {loading: true}});
        this.setState({data: []});
        fetch( ssCommonUtils.setEnvPrefix('/email/search'), options )
            .then(response => response.json())
            .then(data => this.setState( {meta: data, metaRequest: {loading: false}} ))
            .catch(error => this.setState( {meta: {}, metaRequest: {loading: false}} ));
    }

    render() {
        const 
        { showModal, toggleEndorsementEmailModal } = this.props;
        return (
            <div>
                <Modal 
                    visible={showModal}
                    closable={false}
                    centered={true}
                    footer={false}
                    width={700}
                    bodyStyle={{ padding: '5px' }}
                >
                    <div className='provider-email-modal-border' />
                    <Row type='flex' justify='space-around' align='middle' style={{ marginBottom: '15px' }}>
                        <Col>
                            <Icon type='audit' style={{ 
                                marginRight: '10px',
                                fontSize: '22px'
                            }} />
                            <span className='provider-endorsement-email-modal-header'>
                                {'Endorsement Email(s)'}
                            </span>
                        </Col>
                    </Row>
                        <div>
                        <div className='provider-endrosements-controls'>
                            <Button 
                                size='small'
                                icon='close-circle'
                                style={{ 
                                    width: '120px',
                                    borderRadius: '20px'
                                }}
                                onClick={() => toggleEndorsementEmailModal()}
                            >
                                {'Close'}
                            </Button>
                        </div>
                    <EndorsementData email={this.state} {...this.props} />
                    </div>
                </Modal>
            </div>
        );
    }
}